import React from 'react'
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import Sidebar from "../../../../../components/Sidebar";
import PageHeader from "../../../../../components/PageHeader";
import {toast} from "react-toastify";
import moment from "moment";
import DatePicker, {registerLocale} from "react-datepicker";
import {getSchoolYear} from "../../../../../utils/authority";
import GradeManager from "../../../../../components/Grade";
import ClassRoomController from "../../../../../services/data-declaration/class-room-controller";
import AddressManager from "../../../../../components/Address";
import StudentController from "../../../../../services/system/student/student-controller";
import vi from "date-fns/locale/vi";
import DiscountAdmissionsRegisterController
    from "../../../../../services/system/discount-admissions-register/discount-admissions-register-controller";
import DiscountAdmissionsZoneController
    from "../../../../../services/system/discount-admissions-zone/discount-admissions-zone-controller";
import DiscountAdmissionsSpecialController
    from "../../../../../services/system/discount-admissions-special/discount-admissions-special-controller";
registerLocale("vi", vi);
function withRouter(Component) {
    return (props) => <Component {...props} navigate={useNavigate()} params={useSearchParams()} />;
}
class EditStudentManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            "autoGenCode": true,
            "bietBoi": false,
            "birthday": null,
            "birthdayFather": null,
            "birthdayGiamHo": null,
            "birthdayMother": null,
            "cheDoChinhSach": "CHE_DO_CHINH_SACH_1",
            "cheDoHoTro": "CHE_DO_HO_TRO_1",
            "choO": "TRONG_TRUONG",
            "code": "",
            "currentClassRoomId": 0,
            "dangDay": null,
            "dangVien": false,
            "dienHocSinh": "DIEN_HOC_SINH_1",

            "doanDay": null,
            "doanVien": false,
            "doiDay": null,
            "doiTuongUuTien": "UU_TIEN_1",
            "doiVien": false,
            "email": "",
            "ethnic": "KINH",
            "fatherDanToc": false,
            "fullName": "",
            "fullNameFather": "",
            "fullNameGiamHo": "",
            "fullNameMother": "",
            "gender": "MALE",
            "gradeId": "",
            "heHocNN": "TIENG_ANH",
            "hinhThuc": "TRUNG_TUYEN",
            "identify": "",
            "ishocTruongTrinhGDBo": true,
            "iskhuyetTat": false,
            "jobFather": "",
            "jobGiamHo": "",
            "jobMother": "",
            "khuyetTat": "KHUYET_TAT_1",
            "mailFather": "",
            "mailGiamHo": "",
            "mailMother": "",
            "motherDanToc": false,
            "nhomMau": "NHOM_MAU_1",
            "noiSinh": "",
            "phone": "",
            "phoneFather": "",
            "phoneGiamHo": "",
            "phoneHome": "",
            "phoneMother": "",
            "pointDegree": "TRUNG_BINH",
            "queQuan": "",
            "religion": "NO",
            "schoolDay":null,
            "sodangbo": "",
            "state": "CHUA_PHANLOP",
            "taiDinhCu": false,
            "tamTru": "",
            "tengoiEthnnic": "",
            "thanhPhanParent": "THANH_PHAN_PARENT_1",
            "thuongTru": "",
            "address": "",
            "wardCode": "",
            "provinceCode": "",
            "districtCode": "",
            yearId: parseInt(getSchoolYear()),
            "zone": "",
            "discountAdmissionsZoneId": -1,
            "discountAdmissionsRegisterId": -1,
            listClassRoom: [],
            listDiscountRegister: [],
            listDiscountZone: [],
            listDiscountSpecial: [],
            listDiscountSpecialSelect: [],
            listDiscountSpecialId: [],
        };
    }

    componentWillMount() {
        const [searchparams] = this.props.params;
        let studentId = searchparams.get("id");
        this.getListClassRoom()
        this.getDetailStudent(studentId)
    }
    getDiscount(){
        this.getListConfigDiscountRegister()
        this.getListConfigDiscountZone()
        this.getListConfigDiscountSpecial()
    }
    getDetailStudent = (studentId) => {
        StudentController.detail(studentId, res => {
            let data = res.data
            if (res.success){
                this.setState({
                    "id": data.id,
                    "gradeId": data.grade,
                    "bietBoi": data.bietBoi,
                    "birthday": data.birthday,
                    "birthdayFather": data.birthdayFather,
                    "birthdayGiamHo": data.birthdayGiamHo,
                    "birthdayMother": data.birthdayMother,
                    "cheDoChinhSach": data.cheDoChinhSach,
                    "cheDoHoTro":  data.cheDoHoTro,
                    "choO": data.choO,
                    "code": data.code,
                    "currentClassRoomId": data.currentClassRoomRes?.id,
                    "dangDay": data.dangDay,
                    "dangVien":  data.dangVien,
                    "dienHocSinh": data.dienHocSinh,
                    "districtId": data.districtRes?.code,
                    "doanDay": data.doanDay,
                    "doanVien": data.doanVien,
                    "doiDay": data.doiDay,
                    "doiTuongUuTien": data.doiTuongUuTien,
                    "doiVien": data.doiVien,
                    "email": data.email,
                    "ethnic": data.ethnic,
                    "fatherDanToc":  data.fatherDanToc,
                    "fullName": data.fullName,
                    "fullNameFather":  data.fullNameFather,
                    "fullNameGiamHo":  data.fullNameGiamHo,
                    "fullNameMother":  data.fullNameMother,
                    "gender":  data.gender,
                    "grade":  data.grade,
                    "heHocNN":  data.heHocNN,
                    "hinhThuc":  data.hinhThuc,
                    "identify":  data.identify,
                    "ishocTruongTrinhGDBo":  data.ishocTruongTrinhGDBo,
                    "iskhuyetTat":  data.iskhuyetTat,
                    "jobFather":  data.jobFather,
                    "jobGiamHo":  data.jobGiamHo,
                    "jobMother":  data.jobMother,
                    "khuyetTat": data.khuyetTat,
                    "mailFather": data.mailFather,
                    "mailGiamHo": data.mailGiamHo,
                    "mailMother": data.mailMother,
                    "motherDanToc": data.motherDanToc,
                    "nhomMau": data.nhomMau,
                    "noiSinh": data.noiSinh,
                    "phone":  data.noiSinh,
                    "phoneFather":  data.phoneFather,
                    "phoneGiamHo":  data.phoneGiamHo,
                    "phoneHome":  data.phoneHome,
                    "phoneMother":  data.phoneMother,
                    "pointDegree":  data.pointDegree,
                    "provinceId":  data.provinceRes?.code,
                    "queQuan":  data.queQuan,
                    "religion":  data.religion,
                    "schoolDay": data.schoolDay,
                    "sodangbo": data.sodangbo,
                    "state": data.state,
                    "taiDinhCu": data.taiDinhCu,
                    "tamTru": data.tamTru,
                    "address": data.tamTru,
                    "tengoiEthnnic": data.tengoiEthnnic,
                    "thanhPhanParent": data.thanhPhanParent,
                    "thuongTru": data.thuongTru,
                    "wardId": data.wardRes?.code,
                    "discountAdmissionsZoneId": data.discountAdmissionsZoneRes?.id,
                    "discountAdmissionsRegisterId": data.discountAdmissionsRegisterRes?.id,
                    "listDiscountSpecialSelect": data.discountAdmissionsSpecialRes
                }, () =>{
                    this.getDiscount();
                })
            } else {
                toast.error("Đã xảy ra lỗi! " + res.message)
            }

        })
    };
    getListConfigDiscountRegister() {
        let payload = {
            gradeType: this.state.gradeId,
            yearId: parseInt(getSchoolYear()),
        };
        DiscountAdmissionsRegisterController.listDiscountRegister(payload, res => {
            this.setState({
                showLoading: false,
                listDiscountRegister: res.data.discountAdmissionsRes
            });
        })
    }
    getListConfigDiscountZone() {
        let payload = {
            gradeType: this.state.gradeId,
            yearId: parseInt(getSchoolYear()),
        };
        DiscountAdmissionsZoneController.listDiscountZone(payload, res => {
            this.setState({
                showLoading: false,
                listDiscountZone: res.data.discountAdmissionsRes,
            });
        })
    }
    getListConfigDiscountSpecial() {
        let payload = {
            gradeType: this.state.gradeId,
            yearId: parseInt(getSchoolYear()),
        };
        DiscountAdmissionsSpecialController.listDiscountSpecial(payload, res => {
            this.setState({
                showLoading: false,
                listDiscountSpecial: res.data.specialResList,
            });
            res.data.specialResList.forEach((specialInfo, index) => {
                this.state.listDiscountSpecialSelect.forEach(specialSelect =>{
                    if (specialInfo.id == specialSelect.id){
                        this.state.listDiscountSpecialId[index] = specialInfo.id;
                    }
                })
            })
        })
    }
    getListClassRoom = () => {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            "sort": "created_at desc"
        };
        ClassRoomController.list(payload, res => {
            this.setState({
                showLoading: false,
                listClassRoom: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    };
    renderClassRoom = () => {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    renderDiscountZone = () => {
        return this.state.listDiscountZone.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    renderDiscountRegister = () => {
        return this.state.listDiscountRegister.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    renderDiscountSpecial = () => {
        return this.state.listDiscountSpecial.map((item, index) =>
            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                <input
                    type="checkbox"
                    maxLength={255}
                    checked={this.state.listDiscountSpecialId.includes(item.id)}
                    className="form-control shadow-none check-box-type"
                    value={item.id}
                    onChange={(event) => {
                        this.state.listDiscountSpecialId[index] =  event.target.checked?parseInt(event.target.value): ""
                        this.setState(this.state.listDiscountSpecialId)
                    }}
                />{item.name}
            </div>
        )
    };
    onEdit = () => {
        let {fullName} = this.state;
        if (fullName == "" || fullName.length < 5){
            toast.error("Tên học sinh phải lớn hơn 6 ký tự");
        }else if(this.state.gradeId == ""){
            toast.error("Vui lòng chọn khối học");
        }else if(this.state.address == "" || this.state.wardId == undefined || this.state.provinceId==undefined || this.state.districtId == undefined){
            toast.error("Vui lòng nhập địa chỉ học sinh");
        }else if (!(this.state.fullNameFather !== "" && this.state.birthdayFather !== "" && this.state.jobFather !== ""  && this.state.phoneFather !== ""  && this.state.mailFather !== "") &&
            !(this.state.fullNameMother !== "" && this.state.birthdayMother !== "" && this.state.jobMother !== ""  && this.state.phoneMother !== ""  && this.state.mailMother !== "") &&
            !(this.state.fullNameGiamHo !== "" && this.state.birthdayGiamHo !== "" && this.state.jobGiamHo !== ""  && this.state.phoneGiamHo !== ""  && this.state.mailGiamHo !== "")
        ) {
            toast.error("Vui lòng nhập đủ thông tin của ít nhất 1 người(Bố hoặc mẹ hoặc người giám hộ");
        }else {
            let discountAdmissionsSpecials = [];
            this.state.listDiscountSpecialId.forEach(discountId => {
                if (Number.isInteger(discountId)){
                    discountAdmissionsSpecials.push(discountId);
                }
            })
            let payload = {
                "id": this.state.id,
                "autoGenCode": this.state.autoGenCode,
                "bietBoi": this.state.bietBoi,
                "birthday": this.state.birthday,
                "birthdayFather": this.state.birthdayFather,
                "birthdayGiamHo": this.state.birthdayGiamHo,
                "birthdayMother": this.state.birthdayMother,
                "cheDoChinhSach": this.state.cheDoChinhSach,
                "cheDoHoTro": this.state.cheDoHoTro,
                "choO": this.state.choO,
                "code": this.state.code,
                "currentClassRoomId": this.state.currentClassRoomId,
                "dangDay": this.state.dangDay,
                "dangVien":  this.state.dangVien,
                "dienHocSinh": this.state.dienHocSinh,
                "districtCode": this.state.districtId,
                "doanDay": this.state.doanDay,
                "doanVien": this.state.doanVien,
                "doiDay": this.state.doiDay,
                "doiTuongUuTien": this.state.doiTuongUuTien,
                "doiVien": this.state.doiVien,
                "email": this.state.email,
                "ethnic": this.state.ethnic,
                "fatherDanToc":  this.state.fatherDanToc,
                "fullName": this.state.fullName,
                "fullNameFather":this.state.fullNameFather,
                "fullNameGiamHo": this.state.fullNameGiamHo,
                "fullNameMother": this.state.fullNameMother,
                "gender": this.state.gender,
                "grade": this.state.grade,
                "heHocNN": this.state.heHocNN,
                "hinhThuc": this.state.hinhThuc,
                "identify": this.state.identify,
                "ishocTruongTrinhGDBo": this.state.ishocTruongTrinhGDBo,
                "iskhuyetTat": this.state.iskhuyetTat,
                "jobFather": this.state.jobFather,
                "jobGiamHo": this.state.jobGiamHo,
                "jobMother": this.state.jobMother,
                "khuyetTat": this.state.khuyetTat,
                "mailFather": this.state.mailFather,
                "mailGiamHo": this.state.mailGiamHo,
                "mailMother": this.state.mailMother,
                "motherDanToc": this.state.motherDanToc,
                "nhomMau": this.state.nhomMau,
                "noiSinh": this.state.noiSinh,
                "phone": this.state.phone,
                "phoneFather": this.state.phoneFather,
                "phoneGiamHo": this.state.phoneGiamHo,
                "phoneHome": this.state.phoneHome,
                "phoneMother":this.state.phoneMother,
                "pointDegree": this.state.pointDegree,
                "provinceCode": this.state.provinceId,
                "queQuan": this.state.queQuan,
                "religion": this.state.religion,
                "schoolDay": this.state.schoolDay,
                "sodangbo": this.state.sodangbo,
                "state": this.state.state,
                "taiDinhCu": this.state.taiDinhCu,
                "tamTru": this.state.address,
                "tengoiEthnnic": this.state.tengoiEthnnic,
                "thanhPhanParent": this.state.thanhPhanParent,
                "thuongTru": this.state.thuongTru,
                "wardCode": this.state.wardId,
                "yearId": parseInt(getSchoolYear()),
                "zone": this.state.zone,
                "discountAdmissionsZoneId": parseInt(this.state.discountAdmissionsZoneId),
                "discountAdmissionsRegisterId":  parseInt(this.state.discountAdmissionsRegisterId),
                "discountAdmissionsSpecials": discountAdmissionsSpecials,
            }
            StudentController.edit(payload, res => {
                if (res.success){
                    this.props.navigate('/ad-sas-school/quan-ly-thong-tin-hoc-sinh');
                    toast.success("Sửa sinh thành công!")
                } else {
                    toast.error("Đã xảy ra lỗi! " + res.message)
                }
            })
        }
    }
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        }, ()=>{
            this.getDiscount();
        })
    }
    render() {
        let {gradeId, address, wardId, districtId, provinceId} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="student-info-management" parentClass="student-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Thông tin học sinh"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>SỬA THÔNG TIN HỌC SINH</h2>
                                        <div className="row">
                                            <div className="col-12 d-flex mb-2 bg-top-title">
                                                THÔNG TIN LỚP HỌC
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Khối(<span  style={{color: "red",}}>*</span>)</label>
                                                <GradeManager
                                                    gradeId={gradeId}
                                                    onUpdateGrade={(gradeId) => this.onUpdateGrade(gradeId)}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Lớp</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.currentClassRoomId}
                                                    onChange={(e) => {
                                                        this.state.currentClassRoomId = e.target.value;
                                                        this.setState({
                                                            currentClassRoomId: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="0">Chọn lớp</option>
                                                    {this.renderClassRoom()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Trạng thái(<span  style={{color: "red",}}>*</span>)</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.state}
                                                    onChange={(e) => {
                                                        this.state.state = e.target.value;
                                                        this.setState({
                                                            state: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="">Chọn trạng thái học</option>
                                                    <option value="CHUA_PHANLOP">Chưa phân lớp</option>
                                                    <option value="DANG_HOC">Đang học</option>
                                                    <option value="CHUYEN_LOP">Tốt nghiệp</option>
                                                    <option value="NGHI_HOC">Thôi học</option>
                                                    <option value="CHUYEN_LOP">Chuyển lớp</option>
                                                    <option value="LEN_LOP ">Lên lớp</option>
                                                    <option value="CHUYEN_TRUONG">Chuyển trường</option>
                                                </select>
                                            </div>

                                        </div>
                                        <div className="row">
                                            <div className="col-12 d-flex mb-2 bg-top-title">
                                                THÔNG TIN CHUNG
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Họ và tên(<span  style={{color: "red",}}>*</span>)</label>
                                                <input
                                                    placeholder="Nhập họ và tên"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.fullName}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            fullName: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Mã học sinh<span  style={{color: "red",}}>*</span></label>
                                                <input
                                                    placeholder="Nhập mã học sinh"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none col-4"
                                                    value={this.state.code}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            code: event.target.value
                                                        })
                                                    }}
                                                />
                                                <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) => {
                                                                const value = this.state.autoGenCode;
                                                                this.setState({autoGenCode: !value});
                                                            }}
                                                            checked={this.state.autoGenCode}
                                                        />
                                                        {' '}
                                                        Tự động sinh mã
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số điện thoại<span  style={{color: "red",}}>*</span></label>
                                                <input
                                                    placeholder="SĐT liên lạc"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.phone}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            phone: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Email</label>
                                                <input
                                                    placeholder="Email liên lạc"
                                                    maxLength={255} type="email"
                                                    className="form-control shadow-none"
                                                    value={this.state.email}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            email: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày sinh<span  style={{color: "red",}}>*</span></label>
                                                <DatePicker
                                                    locale="vi"
                                                    className="w-auto2 react-datepicker-wrapper2 react-datepicker__input-container form-control shadow-none"
                                                    placeholderText="Ngày sinh"
                                                    selected={this.state.birthday === null ? "" : new Date(this.state.birthday)}
                                                    maxDate={new Date()}
                                                    dateFormat="dd-MM-yyyy"
                                                    isClearable={this.state.birthday === null ? false : true}
                                                    selectsStart
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            this.setState({
                                                                birthday: date === null ? null : moment(date).format("YYYY-MM-DD"),
                                                            })
                                                        }
                                                    }
                                                    birthday={new Date()}
                                                />
                                            </div>
                                            <AddressManager
                                                addressUsually={address}
                                                districtId={districtId}
                                                provinceId={provinceId}
                                                wardId={wardId}
                                                onUpdateAddress={(address, wardId, districtId, provinceId) => this.setState({address: address, districtId: districtId, provinceId: provinceId, wardId: wardId})}
                                            />
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Số đăng bộ</label>
                                                <input
                                                    placeholder="Nhập số đăng bộ"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.sodangbo}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            sodangbo: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Giới tính</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.gender}
                                                    onChange={(e) => {
                                                        this.state.gender = e.target.value;
                                                        this.setState({
                                                            gender: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="MALE">Nam</option>
                                                    <option value="FEMALE">Nữ</option>
                                                    <option value="OTHER">Khác</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ngày vào trường</label>
                                                <DatePicker
                                                    locale="vi"
                                                    className="w-auto2 react-datepicker-wrapper2 react-datepicker__input-container form-control shadow-none"
                                                    placeholderText="Ngày vào trường"
                                                    selected={this.state.schoolDay === null ? "" : new Date(this.state.schoolDay)}
                                                    maxDate={new Date()}
                                                    dateFormat="dd-MM-yyyy"
                                                    isClearable={this.state.schoolDay === null ? false : true}
                                                    selectsStart
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            this.setState({
                                                                schoolDay: date === null ? null : moment(date).format("YYYY-MM-DD"),
                                                            })
                                                        }
                                                    }
                                                    schoolDay={new Date()}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Hình thức</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.hinhThuc}
                                                    onChange={(e) => {
                                                        this.state.hinhThuc = e.target.value;
                                                        this.setState({
                                                            hinhThuc: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="TRUNG_TUYEN">Trúng tuyển</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Nơi sinh</label>
                                                <input
                                                    placeholder="Nhập nơi sinh ra"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.noiSinh}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            noiSinh: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Quê quán</label>
                                                <input
                                                    placeholder="Nhập quê quán"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.queQuan}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            queQuan: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Dân tộc</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.ethnic}
                                                    onChange={(e) => {
                                                        this.state.ethnic = e.target.value;
                                                        this.setState({
                                                            ethnic: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="KINH">Kinh</option>
                                                    <option value="OTHER">Khác</option>
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Tôn giáo</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.religion}
                                                    onChange={(e) => {
                                                        this.state.religion = e.target.value;
                                                        this.setState({
                                                            religion: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="NO">Không</option>
                                                    <option value="YES">Có</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12 d-flex mb-2 bg-top-title">
                                                ƯU ĐÃI HỌC PHÍ
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ưu đãi tuyển sinh theo khu vực</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.discountAdmissionsZoneId}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            discountAdmissionsZoneId: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="">Chọn ưu đãi tuyển sinh khu vực</option>
                                                    {this.renderDiscountZone()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ưu đãi tuyển sinh ngày đăng ký</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.discountAdmissionsRegisterId}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            discountAdmissionsRegisterId: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="">Chọn ưu đãi tuyển sinh ngày đăng ký</option>
                                                    {this.renderDiscountRegister()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Ưu đãi tuyển sinh đặc biệt</label>
                                            </div>
                                            {this.renderDiscountSpecial()}
                                        </div>
                                        <div className="row">
                                            <div className="col-12 d-flex mb-2 bg-top-title">
                                                THÔNG TIN GIA ĐÌNH
                                            </div>
                                            <div className="col-6 d-flex mb-2">
                                                <label className="col-12 label-item pl-0">Thành phần gia đình(Bắt buộc nhập Cha hoặc mẹ hoặc Người giám hộ)</label>
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-6 d-flex mb-2">
                                                <div className="checkbox clearfix mr-5">
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) => {
                                                                const value = this.state.fatherDanToc;
                                                                this.setState({fatherDanToc: !value});
                                                            }}
                                                            checked={this.state.fatherDanToc}
                                                        />
                                                        {' '}
                                                        Có bố là dân tộc
                                                    </label>
                                                </div>
                                                <div className="checkbox clearfix">
                                                    <label>
                                                        <input
                                                            type="checkbox"
                                                            onChange={(e) => {
                                                                const value = this.state.motherDanToc;
                                                                this.setState({motherDanToc: !value});
                                                            }}
                                                            checked={this.state.motherDanToc}
                                                        />
                                                        {' '}
                                                        Có mẹ là dân tộc
                                                    </label>
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 d-flex mb-2 row">
                                                <label className="col-xs-12 col-sm-12 col-md-12 label-item pl-0">Thông tin cha</label>
                                                <div className="col-xs-12 col-sm-12 col-md-2 d-flex mb-2 row">
                                                    <label className="col-xs-12 col-sm-12 col-md-12 label-item pl-0">Họ tên cha</label>
                                                    <input
                                                        placeholder="Nhập họ tên cha"
                                                        maxLength={255} type="text"
                                                        className="form-control shadow-none"
                                                        value={this.state.fullNameFather}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                fullNameFather: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-2 d-flex mb-2 row">
                                                    <label className="col-xs-12 col-sm-12 col-md-12 label-item pl-0">Nghề nghiệp cha</label>
                                                    <input
                                                        placeholder="Nghề nghiệp cha"
                                                        maxLength={255} type="text"
                                                        className="form-control shadow-none"
                                                        value={this.state.jobFather}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                jobFather: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-2 d-flex mb-2 row">
                                                    <label className="col-xs-12 col-sm-12 col-md-12 label-item pl-0">SĐT cha</label>
                                                    <input
                                                        placeholder="SĐT cha"
                                                        maxLength={255} type="text"
                                                        className="form-control shadow-none"
                                                        value={this.state.phoneFather}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                phoneFather: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-2 d-flex mb-2 row">
                                                    <label className="col-xs-12 col-sm-12 col-md-12 label-item pl-0">Email cha</label>
                                                    <input
                                                        placeholder="Email cha"
                                                        maxLength={255} type="text"
                                                        className="form-control shadow-none"
                                                        value={this.state.mailFather}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                mailFather: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-2 d-flex mb-2 row">
                                                    <label className="col-xs-12 col-sm-12 col-md-12 label-item pl-0">Ngày sinh cha</label>
                                                    <DatePicker
                                                        locale="vi"
                                                        className="w-auto2 react-datepicker-wrapper2 react-datepicker__input-container form-control shadow-none mt-1 mr-1"
                                                        placeholderText="Ngày sinh cha"
                                                        selected={this.state.birthdayFather === null ? "" : new Date(this.state.birthdayFather)}
                                                        maxDate={new Date()}
                                                        dateFormat="dd-MM-yyyy"
                                                        isClearable={this.state.birthdayFather === null ? false : true}
                                                        selectsStart
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        onChange={
                                                            (date) => {
                                                                this.setState({
                                                                    birthdayFather: date === null ? null : moment(date).format("YYYY-MM-DD"),
                                                                })
                                                            }
                                                        }
                                                        birthdayFather={new Date()}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 d-flex mb-2 row">
                                                <label className="col-xs-12 col-sm-12 col-md-12 label-item pl-0">Thông tin mẹ</label>
                                                <div className="col-xs-12 col-sm-12 col-md-2 d-flex mb-2 row">
                                                    <label className="col-xs-12 col-sm-12 col-md-12 label-item pl-0">Họ tên cha</label>
                                                    <input
                                                        placeholder="Nhập họ tên mẹ"
                                                        maxLength={255} type="text"
                                                        className="form-control shadow-none"
                                                        value={this.state.fullNameMother}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                fullNameMother: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-2 d-flex mb-2 row">
                                                    <label className="col-xs-12 col-sm-12 col-md-12 label-item pl-0">Nghề nghiệp mẹ</label>
                                                    <input
                                                        placeholder="Nhập nghề nghiệp mẹ"
                                                        maxLength={255} type="text"
                                                        className="form-control shadow-none"
                                                        value={this.state.jobMother}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                jobMother: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-2 d-flex mb-2 row">
                                                    <label className="col-xs-12 col-sm-12 col-md-12 label-item pl-0">SĐT mẹ</label>
                                                    <input
                                                        placeholder="Nhập SĐT mẹ"
                                                        maxLength={255} type="text"
                                                        className="form-control shadow-none"
                                                        value={this.state.phoneMother}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                phoneMother: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-2 d-flex mb-2 row">
                                                    <label className="col-xs-12 col-sm-12 col-md-12 label-item pl-0">Gmail mẹ</label>
                                                    <input
                                                        placeholder="Nhập Gmail mẹ"
                                                        maxLength={255} type="text"
                                                        className="form-control shadow-none"
                                                        value={this.state.mailMother}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                mailMother: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-2 d-flex mb-2 row">
                                                    <label className="col-xs-12 col-sm-12 col-md-12 label-item pl-0">Gmail mẹ</label>
                                                    <DatePicker
                                                        locale="vi"
                                                        className="w-auto2 react-datepicker-wrapper2 react-datepicker__input-container form-control shadow-none mt-1 mr-1"
                                                        placeholderText="Ngày sinh mẹ"
                                                        selected={this.state.birthdayMother === null ? "" : new Date(this.state.birthdayMother)}
                                                        maxDate={new Date()}
                                                        dateFormat="dd-MM-yyyy"
                                                        isClearable={this.state.birthdayMother === null ? false : true}
                                                        selectsStart
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        onChange={
                                                            (date) => {
                                                                this.setState({
                                                                    birthdayMother: date === null ? null : moment(date).format("YYYY-MM-DD"),
                                                                })
                                                            }
                                                        }
                                                        birthdayMother={new Date()}
                                                    />
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 d-flex mb-2 row">
                                                <label className="col-xs-12 col-sm-12 col-md-12 mt-1 label-item pl-0">Thông tin người bảo hộ</label>
                                                <div className="col-xs-12 col-sm-12 col-md-2 d-flex mb-2 row">
                                                    <label className="col-xs-12 col-sm-12 col-md-12 label-item pl-0">Nhập họ tên NBH</label>
                                                    <input
                                                        placeholder="Nhập họ tên NBH"
                                                        maxLength={255} type="text"
                                                        className="form-control shadow-none"
                                                        value={this.state.fullNameGiamHo}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                fullNameGiamHo: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-2 d-flex mb-2 row">
                                                    <label className="col-xs-12 col-sm-12 col-md-12 label-item pl-0">Nghề nghiệp NBH</label>
                                                    <input
                                                        placeholder="Nhập nghề nghiệp NBH"
                                                        maxLength={255} type="text"
                                                        className="form-control shadow-none"
                                                        value={this.state.jobGiamHo}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                jobGiamHo: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-2 d-flex mb-2 row">
                                                    <label className="col-xs-12 col-sm-12 col-md-12 label-item pl-0">SĐT NBH</label>
                                                    <input
                                                        placeholder="SĐT NBH"
                                                        maxLength={255} type="text"
                                                        className="form-control shadow-none"
                                                        value={this.state.phoneGiamHo}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                phoneGiamHo: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-2 d-flex mb-2 row">
                                                    <label className="col-xs-12 col-sm-12 col-md-12 label-item pl-0">Gmail NBH</label>
                                                    <input
                                                        placeholder="Gmail NBH"
                                                        maxLength={255} type="text"
                                                        className="form-control shadow-none"
                                                        value={this.state.mailGiamHo}
                                                        onChange={(event) => {
                                                            this.setState({
                                                                mailGiamHo: event.target.value
                                                            })
                                                        }}
                                                    />
                                                </div>
                                                <div className="col-xs-12 col-sm-12 col-md-2 d-flex mb-2 row">
                                                    <label className="col-xs-12 col-sm-12 col-md-12 label-item pl-0">Ngày sinh NBH</label>
                                                    <DatePicker
                                                        locale="vi"
                                                        className="w-auto2 react-datepicker-wrapper2 react-datepicker__input-container form-control shadow-none mt-1 mr-1"
                                                        placeholderText="Ngày sinh NBH"
                                                        selected={this.state.birthdayGiamHo === null ? "" : new Date(this.state.birthdayGiamHo)}
                                                        maxDate={new Date()}
                                                        dateFormat="dd-MM-yyyy"
                                                        isClearable={this.state.birthdayGiamHo === null ? false : true}
                                                        selectsStart
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        onChange={
                                                            (date) => {
                                                                this.setState({
                                                                    birthdayGiamHo: date === null ? null : moment(date).format("YYYY-MM-DD"),
                                                                })
                                                            }
                                                        }
                                                        birthdayGiamHo={new Date()}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-12">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                            disabled={this.state.fullName == ""}
                                            onClick={()=> {
                                                this.onEdit()
                                            }}
                                        >
                                            Lưu
                                        </button>
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/quan-ly-thong-tin-hoc-sinh"
                                                }}
                                            >
                                                Hủy bỏ
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(EditStudentManagement)
